import request from '@/utils/request';
import { requestFetch, REQUEST_TYPE } from '../utils/requestFetch';
import BASIC_CONSTANT from '../constants/basic.constants.js/basic.constants.js';
import URL_CONSTANT from '../constants/url.constants';
import SystemError from '../utils/exception/SystemError';
import Router from 'next/router';

export default class ChannelClass {
  constructor(data = {}) {
    this.setData(data);
  }
  setData(data) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  getData(key) {
    return this[key];
  }

  async isExistVideo(channelId, token) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/${channelId}/itemCount`,
        REQUEST_TYPE.GET,
        {},
        { token }
      );
      if (result.code === 200) return result.data;
      if (result.code === 401) Router.push(URL_CONSTANT.login.url);
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async registPlayer(channelId, playerId, token) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/${channelId}/playerRegistration`,
        REQUEST_TYPE.POST,
        {
          playerId: playerId,
        },
        { token }
      );
      if (result.code === 200) return 'success';
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async getMyChannel(token) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/myChannel`,
        REQUEST_TYPE.GET,
        {},
        { token }
      );
      if (result.code === 200) return result.data;
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async postChannels(channelName, channelImageUrl, image, token) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels`,
        REQUEST_TYPE.POST,
        {
          channelImageUrl,
          channelName,
          image,
        },
        { token },
        true
      );
      if (result.code === 200) return result.data;
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }
  async getInviteChannels(token) {
    try {
      const result = await requestFetch(`${BASIC_CONSTANT.BASE_URL}channels/inviteMe`, REQUEST_TYPE.GET, {}, { token });
      if (result.code === 200) return result.data;
      if (result.code === 401) Router.push(URL_CONSTANT.login.url);
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async getProfileImages(token) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/preparedProfileImages`,
        REQUEST_TYPE.GET,
        {},
        { token }
      );
      if (result.code === 200) return result.data;
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async postJoinChannel(token, id) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/${id}/join`,
        REQUEST_TYPE.POST,
        {},
        { token }
      );

      if (result.code === 200) return result;
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async rejectChannel(token, id) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/${id}/withdraw`,
        REQUEST_TYPE.DELETE,
        {},
        { token }
      );

      if (result.code === 200) return result;
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }

  async channelDetail(channelId, token) {
    try {
      const result = await requestFetch(
        `${BASIC_CONSTANT.BASE_URL}channels/${channelId}`,
        REQUEST_TYPE.GET,
        {},
        { token }
      );

      if (result.code === 200) return result.data;
    } catch (e) {
      return SystemError.processRequestError(e);
    }
  }
}
